import { gql, useQuery } from "@apollo/client";
import { AppliedPropertyFeatures, Feature } from "types/gql-types";

const QUERY = gql`
  query AppliedPropertyFeatures {
    appliedPropertyFeatures {
      id
      name
    }
  }
`;

/** Check if a feature is enabled on any property that the viewer has applied to */
export const useAppliedPropertyFeature = (featureName: Feature): boolean => {
  const query = useQuery<AppliedPropertyFeatures>(QUERY);

  if (query.loading || query.error || !query.data || !query.data.appliedPropertyFeatures) {
    return false;
  }

  return query.data.appliedPropertyFeatures.some(({ name }) => name === featureName);
};
